var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("ContactNetwork")]),_c('h2',[_vm._v("THIS IS ContactNetwork")]),_c('ul',{staticClass:"example"},[_c('li',[_c('router-link',{attrs:{"to":"/EvContract"}},[_vm._v("Ev EvStake")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }